exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BundlePreview__bundle___YoEuCwQd {\n  /* Using single-cell grid to stack elements,\n    while preserving the size of images. */\n  display: grid;\n  grid-template-areas: \"main\";\n  width: 100%;\n  height: 100%;\n}\n.BundlePreview__bundleItem___3vGB8tqE {\n  grid-area: main;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  object-fit: contain;\n}\n.BundlePreview__animatedItemDown___rgLxo_6Q {\n  animation: BundlePreview__down___3Tvn59t0 600ms ease-in normal;\n}\n@keyframes BundlePreview__down___3Tvn59t0 {\nfrom {\n    transform: translateY(-5%);\n}\n}\n", ""]);
// Exports
exports.locals = {
	"bundle": "BundlePreview__bundle___YoEuCwQd",
	"bundleItem": "BundlePreview__bundleItem___3vGB8tqE",
	"animatedItemDown": "BundlePreview__animatedItemDown___rgLxo_6Q",
	"down": "BundlePreview__down___3Tvn59t0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/configurator/components/Preview/BundlePreview.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = naTf
// module chunks = 3